import axiosInstance from '../../axios/axios-instance';
import { SignedTileDto } from 'shared/dto/project/signed-tile.dto';
import { TileClickResponseDto } from 'shared/enums/project/tile-click-response.dto';

export const profileSurveyClick = {
  /**
   * Handles a profile survey click event.
   * @param signedTileDto - The signed tile data.
   * @returns The result of the profile survey click process.
   */
  async sendTileClick(signedTileDto: SignedTileDto, verisoulSessionId?: string): Promise<TileClickResponseDto> {
    const response = await axiosInstance.post('/profile-survey-click/tile-click', signedTileDto, {
      headers: {
        'x-session-id': verisoulSessionId,
        'x-rewardbloom-signature': signedTileDto.signature,
      },
    });
    return response.data as TileClickResponseDto;
  },

  /**
   * Submits a user rating for a tile interaction if within valid range (1–5).
   *
   * @param tileDetailsDto - Tile metadata string
   * @param tileDetailsSignature - Signature verifying tileDetailsDto
   * @param rating - User rating between 1 and 5
   */
  async submitUserRating(tileDetailsDto: string, tileDetailsSignature: string, rating: number): Promise<void> {
    if (rating < 1 || rating > 5) {
      return;
    }
    await axiosInstance.post('/profile-survey-click/user-rating', {
      tileDetailsDto: tileDetailsDto,
      tileDetailsSignature: tileDetailsSignature,
      rating: rating,
    });
  },
};
